import React from 'react';

import {useSwipeable} from "react-swipeable";
import {BaseProps} from "../../../infrastructure/models/props/base-props";

export class SwipeableProps extends BaseProps {
  innerRef: React.ReactElement;
  onSwiped: Function;
  onSwipedLeft: Function;
  onSwipedRight: Function;
  onSwipedUp: Function;
  onSwipedDown: Function;
  onSwiping: Function;
  className: String;
}

export const Swipeable = (props: SwipeableProps) => {
  const handlers = useSwipeable({
    onSwipedRight: () => props.onSwipedRight && props.onSwipedRight(),
    onSwipedLeft: () => props.onSwipedLeft && props.onSwipedLeft(),
    preventDefaultTouchmoveEvent: false,
  });

  const swipeableProps = {
    className: ['swipeable-container', props.className].join(' '),
    ...handlers
  }

  return (
    <div {...swipeableProps}>
      {
        props.children
      }
    </div>
  )
}
